<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 18 18"
  >
    <rect
      id="사각형_3730"
      data-name="사각형 3730"
      fill="#24589b"
      width="18"
      height="18"
      transform="translate(0 0)"
    />
    <g id="그룹_3749" data-name="그룹 3749" transform="translate(4.556 5.347)">
      <path
        id="패스_1815"
        data-name="패스 1815"
        fill="#fff"
        d="M-2625.469,4711.418h1.793l.46,3.323.294,2.313h.039c.137-.774.284-1.558.431-2.312l.745-3.323h1.47l.764,3.323c.147.745.274,1.528.421,2.313h.049c.088-.784.186-1.558.274-2.312l.471-3.323h1.666l-1.264,7.292h-2.205l-.657-3.175c-.117-.559-.215-1.146-.284-1.7h-.049c-.088.549-.177,1.137-.284,1.7l-.637,3.175h-2.166Z"
        transform="translate(2625.469 -4711.418)"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 18,
    },
    height: {
      type: Number,
      default: 18,
    },
  },
};
</script>
